const DeepCopy = (object: any) => {
    return JSON.parse(JSON.stringify(object));
};

export default DeepCopy;


// WEBPACK FOOTER //
// ./src/UtilityFunctions/DeepCopy.ts